import React from 'react';
import './LevelBadge.css';

const LevelBadge = ({ level, size = 'md' }) => (
  <span className={`z-level-badge z-level-badge--${size}`}>
    <span className="z-level-badge-label">Lv</span>
    <span className="z-level-badge-num">{level}</span>
  </span>
);

export default LevelBadge;
